<div *ngIf='dataYaxis.length > 0'>
    <!-- <canvas baseChart [datasets]="dataYaxis" [labels]="dataXaxis" [options]="lineChartOptions"
        [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="'line'" height="200">
    </canvas> -->
</div>